import api from "./api";
import Category from "@/model/category";

class CategoryApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async getMainCategories(context) {
    const categories = context.data.categories;
    const result = []

    categories.map(item => {
      if (item.superItemCategory === "") {
        result.push(item)
      }
    })

    return result.map(item => {
      return new Category(item)
    })
  }

  async getSubCategories(context) {
    const categories = context.data.categories;
    const items = context.data.items;

    const categoriesByItems = []
    const parentCategoriesByItems = []
    items.filter(item => {
      if (item.itemCategory.length < 3) {
        parentCategoriesByItems.push(item.itemCategory)
      } else {
        categoriesByItems.push(item.itemCategory)
      }
    })

    const results = categories.filter(category => {
      if (category.superItemCategory !== "" && categoriesByItems.includes(category.identifier)) {
        return category
      } else if (category.superItemCategory === ""
        && parentCategoriesByItems.includes(category.identifier)
        && !categoriesByItems.includes(category.identifier)
      ) {
        return category
      }
    });

    return results.map((category: Category) => {
      if (category.superItemCategory === "") {
        category.superItemCategory = category.identifier;
      }
      return category;
    }).filter(item => {
      return new Category(item)
    });
  }

  getFirstSubCategoryByIdentifier(identifier, subCategories): string|null {
    const result = []
    subCategories.map(item => {
      if (item.superItemCategory === identifier) {
        result.push(item);
      }
    });

    if (result.length > 0) {
      return result[0].identifier
    }

    return null;
  }
}

export default new CategoryApi();
